// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfigSTFULL = [
  {
    title: 'Профіль',
    path: '/student/profile',
    icon: icon('ic_user'),
  },
  {
    title: 'Правила',
    path: '/student/intro',
    icon: icon('ic_disabled'),
  },
  {
    title: 'Уроки',
    path: '/student/homeworks',
    icon: icon('ic_analytics'),
  },
  {
    title: 'Месенджер',
    path: '/student/day',
    icon: icon('ic_user'),
  },
  {
    title: 'Щоденник',
    path: '/student/calendar',
    icon: icon('ic_analytics'),
  },
  {
    title: 'Lala info',
    path: '/student/info',
    icon: icon('ic_lock'),
  },
];

export default navConfigSTFULL;
